module.exports = __webpack_public_path__ + "img/118ne.cb7ed4f8.svg";